import PaytableComponent from "slotworks/components/paytable/paytable-component";
import BetOptions from "slotworks/components/betbar/vo/bet-options";
import FlexiToggle, { ToggleEvent } from "slotworks/graphics/elements/flexi-toggle";

export default class PagingPaytableComponent extends PaytableComponent {

    protected pageToggleJumpListeners: Map<FlexiToggle, () => any> = new Map<FlexiToggle, () => any>();

    protected updateControls() {
        super.updateControls();

        for (let i = 0; i < this.totalPages; i++) {
            const pageIndex = i;
            const pageName = this.contentSceneNames[pageIndex];
            const toggle = this.uiLayer.getFlexiToggle(pageName);
            if(toggle) {
                toggle.setEnabled(true);

                const listener = () => this.jumpToPage(pageIndex);
                toggle.on(ToggleEvent.CHANGE, listener);
                this.pageToggleJumpListeners.set(toggle, listener);

                if (pageIndex === this.page) {
                    toggle.setValue(true);
                } else {
                    toggle.setValue(false);
                }
            }
        }
    }

    protected reset() {
        super.reset();

        this.pageToggleJumpListeners.forEach((listener, toggle) => toggle.off(ToggleEvent.CHANGE, listener));
        this.pageToggleJumpListeners.clear();
    }


}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/components/paytable/paytable-component.ts